import { Pipe, PipeTransform, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, of, startWith } from 'rxjs';
import { BdResourceServices } from '../service/resource.service';
import { map } from 'rxjs/operators';
import {
  BdResource,
  ShareableType,
} from '@bindoc-projects/resource-domain-lib';

@Pipe({
  name: 'resourceDisplayName',
  standalone: true,
})
export class BdResourceDisplayNamePipe implements PipeTransform {
  private readonly _resourcesService = inject(BdResourceServices);

  transform(value: string, ...args: string[]): Observable<string> {
    if (args.length === 0) {
      console.warn(
        'Pipe [resourceDisplayName] needs BdResourceName as parameter, example: resourceDisplayName:"market"',
      );
      return of('');
    }

    if (!Object.values(ShareableType).some((it) => it === args[0])) {
      console.warn(
        `Pipe [resourceDisplayName] needs a valid BdResourceName (${Object.values(ShareableType)}) as parameter, given value is`,
        args[0],
      );
      return of('');
    }

    const resourceName = args[0] as ShareableType;

    return this._resourcesService
      .of(resourceName)
      .findById(value)
      .pipe(
        startWith({ name: 'Name wird geladen..' } as BdResource),
        map((resource: BdResource) => resource.name),
        catchError((err) => {
          if (err instanceof HttpErrorResponse && err.status === 403) {
            console.warn(
              `No permission to access resource id=${value} & resourceName=${resourceName}`,
            );
            return of('Keine Berechtigung');
          }
          if (err instanceof HttpErrorResponse && err.status === 404) {
            console.warn(
              `Resource not found id=${value} & resourceName=${resourceName}`,
            );
            return of('Nicht vorhanden');
          }
          if (err instanceof HttpErrorResponse && err.status === 409) {
            console.warn(
              `Resource is in the recycle bin id=${value} & resourceName=${resourceName}`,
            );
            return of('Im Papierkorb');
          }
          console.error(
            `Error loading resource id=${value} & resourceName=${resourceName}`,
            err,
          );
          return of('Resource nicht gefunden');
        }),
      );
  }
}
